// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__188QZ","footerText":"Footer_footerText__2yAU_","contactUs":"Footer_contactUs__19C5i","button":"Footer_button__E5p7j"};